<!--全屏蒙层播放视频-->

<template>
<!-- @click:outside="closeDialog" width="1066" height="600" overlay-color="#000000" overlay-opacity="0.5"  -->

  <!--蒙层-->
  <div style="position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.5);">
    <v-dialog v-model="dialogShow_this" :origin="dialogOrigin" fullscreen hide-overlay class="dialog">
      <!--点击空白区域关闭-->
      <div @click="closeDialog" style="width:100%;height:100%;">
        <video @click.stop="" style="position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);
        width:1066px;height:600px;max-width:calc(100%);margin:0 auto;" controls autoplay muted>
          <source :src="videoSrc" type="video/mp4">
        </video>

        <div style="position:absolute;top:calc(50vh - 300px - 10px);right:calc(50vw - 533px - 40px);
    width:26px;height:26px;background:#c4c4c4;border-radius:50%;cursor:pointer;text-align:center;">
          <p @click="closeDialog" style="line-height:27px;font-size:12px;color:#3a3a3a;" class="iconfontFamily">&#xe60d;</p>
        </div>

      </div>


    </v-dialog>


  </div>







</template>

<script>
export default {
  name: "FullScreenVideo",
  props:["dialogShow","videoSrc","dialogOrigin"],
  data(){
    return{
      dialogShow_this:this.dialogShow,
    }
  },
  watch:{
    dialogShow_this(){
      if(!this.dialogShow_this && this.dialogShow){
        this.$emit("closeDialog","")
      }
    }
  },
  methods:{
    closeDialog(){
      //停止监听
      document.removeEventListener('keyup', this.escCloseVideo);
      this.dialogShow_this = false;
      this.$emit("closeDialog","")
    },

    //按下esc关闭引导视频
    escCloseVideo(e){
      if (e.keyCode === 27) {
        e.stopPropagation();
        this.closeDialog()
      }
    },

  },
  mounted(){
    document.addEventListener('keyup', this.escCloseVideo);
  }


}
</script>

<style scoped>

</style>